import o from "./index.es156.js";
var s = function s(t, e) {
  if (t && e) return o.threeItemsRow;
  if (t || e) return o.twoItemsRow;
};
export { s as stylesColumns };